"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { IMAGE_FILE_TYPES } from "@/libs/builder/consts";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const informationAboutProductsInputs = [
  {
    name: "title",
    type: "string",
    required: true,
    defaultValue: "Multi Tab Title",
  },
  {
    name: "bottomDescription",
    type: "string",
    defaultValue: "Bottom description text",
  },
  {
    name: "ctaText",
    type: "string",
    defaultValue: "Call to Action",
  },
  {
    name: "ctaHref",
    type: "url",
    defaultValue: "/",
  },
  {
    name: "multiTabVariant",
    type: "string",
    enum: ["extended", "buttons", "blogArticles"],
    defaultValue: "extended",
  },
  {
    name: "tabList",
    type: "list",
    defaultValue: [
      {
        title: "Tab 1",
        description: "Content for tab 1",
        image:
          "https://cdn.builder.io/api/v1/image/assets%2Fd1a786c1a5b54cfc9d2a9230b6012b69%2Fb7fe4b5b236f441d8d2b99f2116f3b45",
        subtitleBlog: "Subtitle Blog",
        anchor: "/",
      },
      {
        title: "Tab 2",
        description: "Content for tab 2",
        image:
          "https://cdn.builder.io/api/v1/image/assets%2Fd1a786c1a5b54cfc9d2a9230b6012b69%2Fb7fe4b5b236f441d8d2b99f2116f3b45",
        subtitleBlog: "Subtitle Blog",
        anchor: "/",
      },
      {
        title: "Tab 3",
        description: "Content for tab 3",
        image:
          "https://cdn.builder.io/api/v1/image/assets%2Fd1a786c1a5b54cfc9d2a9230b6012b69%2Fb7fe4b5b236f441d8d2b99f2116f3b45",
        subtitleBlog: "Subtitle Blog",
        anchor: "/",
      },
    ],
    subFields: [
      {
        name: "title",
        type: "string",
      },
      {
        name: "description",
        type: "richText",
      },
      {
        name: "image",
        type: "file",
        allowedFileTypes: IMAGE_FILE_TYPES,
      },
      {
        name: "subtitleBlog",
        type: "string",
      },
      {
        name: "anchor",
        type: "url",
      },
    ],
  },
] as const satisfies Inputs;

export const InformationAboutProductsComponent: RegisteredComponent = {
  name: "InformationAboutProducts",
  component: dynamic(async () =>
    withValidation(
      informationAboutProductsInputs,
      (await import("./InformationAboutProducts")).InformationAboutProducts,
      "InformationAboutProducts"
    )
  ),
  inputs: informationAboutProductsInputs,
};
